import React from "react";

function SpatialRelationDetails() {
      return (
        <p>Spatial Relations Details</p>
        
    );
}


export default SpatialRelationDetails;
